import { gsap } from 'gsap'
/**
 * Subscribe overlay component.
 * @author Dayne Coulson-Hoffacker
 */
export default class PopupModal {
  /**
   * Constructs a new subscribe overlay component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.toggleOverlay = document.querySelector('[data-component="popup-modal"] .popup-modal__overlay')
    this.closeButton = this.element.querySelector('[data-component="popup-modal-close"]')

    // check if cookie exists
    const getCookie = (name) => {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
    }

    if (!getCookie('popup-modal')) {
      this.element.classList.remove('hidden')
    }

    // set cookie for popup modal
    const setCookie = (name, value, days) => {
      let expires = ''
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = `; expires=${date.toUTCString()}`
      }
      document.cookie = `${name}=${value || ''}${expires}; path=/`
    }
    setCookie('popup-modal', 'true', 1)


    // Open subscribe overlay
    this.toggleOverlay.addEventListener('click', () => {
      this.element.classList.add('hidden')
    })

    // Enable close button
    this.closeButton.addEventListener('click', () => {
      this.element.classList.add('hidden')
    })
  }
}



// WEBPACK FOOTER //
// ./components/popup-modal/index.js